import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, nextTick } from "../../../adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { outsideClick } from "@tencentcloud/universal-api";
import { isPC, isH5, isUniFrameWork } from "../../../utils/env";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // Whether to display the bottom pop-up dialog box
  show: {
    type: Boolean,
    default: false,
  },
  // Whether a mask layer is required, the default is true
  modal: {
    type: Boolean,
    default: true,
  },
  // Popup box content area height (excluding mask), default is fit-content
  height: {
    type: String,
    default: "fit-content",
  },
  // Whether the pop-up dialog box can be closed by clicking outside, the default is true
  // uniapp only supports closing the pop-up dialog box by clicking the mask
  closeByClickOutside: {
    type: Boolean,
    default: true,
  },
  // The rounded angle of the top border corners is 0px by default, i.e. right angle by default
  borderRadius: {
    type: String,
    default: "0px",
  },
  title: {
    type: String,
    default: "",
  },
  // Whether to display the top close button, not displayed by default
  showHeaderCloseButton: {
    type: Boolean,
    default: false,
  },
  // Whether to display the submit button at the bottom, not displayed by default
  showFooterSubmitButton: {
    type: Boolean,
    default: false,
  },
  // Bottom submit button text, only valid when showFooterSubmitButton is true
  submitButtonContent: {
    type: String,
    default: () => TUITranslateService.t("确定"),
  },
},
  emits: ["onOpen", "onClose", "onSubmit"],
  setup(__props, { emit: emits }) {

const props = __props




const dialogRef = ref();

watch(
  () => props.show,
  (newVal: boolean, oldVal: boolean) => {
    if (newVal === oldVal) {
      return;
    }
    switch (newVal) {
      case true:
        emits("onOpen", dialogRef);
        nextTick(() => {
          // Effective under web h5
          if (isH5 && !isUniFrameWork) {
            if (props.closeByClickOutside) {
              outsideClick.listen({
                domRefs: dialogRef.value,
                handler: closeBottomPopup,
              });
            }
          }
        });
        break;
      case false:
        emits("onClose", dialogRef);
        break;
    }
  }
);

const closeBottomPopup = () => {
  if (isUniFrameWork || isH5) {
    emits("onClose", dialogRef);
  }
};

const submit = () => {
  emits("onSubmit");
  closeBottomPopup();
};

return { __sfc: true,props, emits, dialogRef, closeBottomPopup, submit, TUITranslateService, isPC, isUniFrameWork }
}

})